import {API} from "@/Composables/api";

const getPlans = async (params = {}) => {
    return API.get(route("admin.plans.index"), params);
};

const getPlan = async (plan) => {
    return API.get(route("admin.plans.show", plan));
};

const storePlan = async (data, params = {}) => {
    return API.post(route("admin.plans.store"), params, data);
};

const updatePlan = async (plan, data, params = {}) => {
    return API.put(route("admin.plans.update", plan), params, data);
};

const deletePlan = async (plan, params = {}) => {
    return API.delete(route("admin.plans.destroy", plan), params);
};

export {getPlans, getPlan, storePlan, updatePlan, deletePlan};
